module.exports = __webpack_public_path__ + "static/img/img1.a539747.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regist/img1.png
// module id = Pj0M
// module chunks = 1